import SubMenuRightContent from 'common-js/components/menu/SubMenuRightContent';
import TopMenu from 'common-js/components/menu/TopMenu';
import {
  BILLING_DATA_PLANS,
  BILLING_INVOICES,
  BILLING_SETTINGS,
  pathMatches,
  withContext,
} from 'common-js/constants/paths';
import { type FC } from 'react';

interface BillingSubMenuProps {
  pathname: string;
}

const BillingSubMenu: FC<BillingSubMenuProps> = ({ pathname }) => (
  <TopMenu titleHref={withContext(BILLING_INVOICES)} rightContent={<SubMenuRightContent />}>
    <TopMenu.Item
      text="Account"
      active={pathMatches(BILLING_INVOICES, pathname) || pathMatches(BILLING_SETTINGS, pathname)}
      href={withContext(BILLING_INVOICES)}
    />
    <TopMenu.Item
      text="Data plans"
      active={pathMatches(BILLING_DATA_PLANS, pathname)}
      href={withContext(BILLING_DATA_PLANS)}
    />
  </TopMenu>
);
export default BillingSubMenu;
